export function landingPathForRoles(roles = []) {
  if (roles.includes('superadmin')) return '/analytics'
  if (roles.includes('admin')) return '/analytics'
  if (roles.includes('auditor')) return '/admin/audit'
  if (roles.includes('ops')) return '/products'
  if (roles.includes('sales')) return '/sales'
  return '/orders'
}
